import { data_dictionary_map } from "root/static/dataDictionary.js"
import { decrypt } from "utils"
import { reverseBuildModelForBigScreen } from "utils/reverseBuildModel.js"
import instance from "../interceptor"
import store from "../store/index"
import { event } from "utils/event"
import { queryPageInfo } from "../api/page"
export async function initBigScreenData(urlQuery) {
  let noswiper = urlQuery.hasOwnProperty("noswiper") && urlQuery.noswiper == 1
  if (!noswiper) {
    const res = await getListOrder(urlQuery)
    if (res?.data?.data?.pageListJson) {
      noswiper = JSON.parse(res.data.data.pageListJson).pages.findIndex(item => item.pageId === urlQuery.pageId) != 0
    }
  }
  if (noswiper) {
    urlQuery.noswiper = 1
  }
  //有list 表示是需要轮播渲染的大屏页
  const pageInfo = await queryPageInfo({
    p: urlQuery.pageId
  })
  if (pageInfo.code === 1 && pageInfo.data.name) {
    document.title = pageInfo.data.name
  }
  if ((urlQuery.hasOwnProperty("noswiper") && urlQuery.noswiper == 1) || sessionStorage.getItem("closeSwiper")) {
    localStorage.setItem("noswiper", 1)
    await initSinglePageData(urlQuery)
  } else {
    const pageList = getListOrder(urlQuery)
    const completePageList = getListData(urlQuery)
    Promise.all([pageList, completePageList]).then(async res => {
      let p1 = res[0]?.data?.data
      const list = res[1]?.data?.data
      list &&
        list.pageList.forEach(page => {
          if (p1) {
            p1.pageListJson = p1.pageListJson.replaceAll(page.encId, page.publicId)
          }
        })
      if (p1 && p1.pageListJson && JSON.parse(p1.pageListJson).pages.length > 1) {
        // 处理大屏中使用1.0的登录页面，此时登录页面不参与轮播
        p1.pageListJson = JSON.parse(p1.pageListJson)
        for (let i = 0; i < p1.pageListJson.pages.length; i++) {
          let item = list.pageList.find(list => list.encId === p1.pageListJson.pages[i].pageId)
          if (item && item.template === "login") {
            p1.pageListJson.pages.splice(i, 1)
          }
        }
        p1.pageListJson = JSON.stringify(p1.pageListJson)
        await initPageListData(urlQuery, p1)
      } else {
        window.localStorage.removeItem("swiperOption")
        await initSinglePageData(urlQuery)
      }
    })
  }
}
async function initSinglePageData(query) {
  let result = await instance.get(`v2/webjson/${query.pageId}/content?a=${0}`)
  let stage = JSON.parse(result.data.data)
  let resultData = decrypt(JSON.stringify(stage), data_dictionary_map)
  //把rem转回px
  reverseBuildModelForBigScreen(resultData)
  //清除组件的active
  clearActive(resultData)
  resultData.event = resultData.event ? event.createPageId(resultData.event, query.pageId) : {}
  resultData.page.children.forEach(stage => {
    stage.pageId = query.pageId
    stage.stageType = resultData.page.stageType
    stage.layoutOption = resultData.page.layoutOption
    stage.width = resultData.page.pageWidth
    stage.height = resultData.page.height
  })
  event.init(resultData.event ? resultData.event : {}, "stage")
  setTimeout(() => {
    store.dispatch("bigScreen/initWebJson", resultData)
  }, 100)
}
async function initPageListData(urlQuery, list) {
  const { pageList, swiperOption } = await originData(urlQuery, list)
  if (swiperOption) {
    window.localStorage.setItem("swiperOption", JSON.stringify(swiperOption))
  }
  const allWebJson = await getAllWebJson(pageList)
  const resultData = formateAllWebJson(allWebJson, urlQuery)
  store.dispatch("bigScreen/initWebJson", resultData)
}
async function originData(query, list) {
  const formatPageList = list || (await getListOrder(query))
  let pageList = null
  //进行过页面排序操作的数据，如果未进行页面排序，则返回值为空
  if (formatPageList) {
    const res = JSON.parse(formatPageList.pageListJson)
    pageList = { pageList: res.pages.map(it => it.pageId), swiperOption: res.swiperOption }
  } else {
    //如果当前websiteid下的已排序的pageId为空，则去获取未排序的pageId
    const originPageList = await getListData(query)
    pageList = { pageList: originPageList.data.data.pageList.map(it => it.encId), time: false }
  }
  return pageList
}
async function getListOrder(query) {
  return instance.get("v2/website-pages/" + query.websiteId + "/get")
}
async function getListData(query) {
  return instance.get("v2/" + query.websiteId + "/page/list", {
    params: {
      p: query.pageId
    }
  })
}

async function getAllWebJson(pageIdList) {
  const allPromise = []
  pageIdList.forEach(pageIdItem => {
    allPromise.push(instance.get(`v2/webjson/${pageIdItem}/content?a=${0}`))
  })
  return Promise.all(allPromise)
}
function formateAllWebJson(allWebJson) {
  let stage = JSON.parse(allWebJson[0].data.data)
  const baseWebJson = decrypt(JSON.stringify(stage), data_dictionary_map)
  const baseUrl = allWebJson[0].config.url
  const basePageId = baseUrl.slice(baseUrl.indexOf("webjson") + "webjson/".length, baseUrl.indexOf("content") - 1)
  const allEvent = {}
  Object.assign(allEvent, event.createPageId(baseWebJson.event, basePageId))
  // baseWebJson.event = event.createPageId(baseWebJson.event, basePageId)
  baseWebJson.page.children.forEach(item => {
    item.pageId = basePageId
    item.stageType = baseWebJson.page.stageType
    item.layoutOption = baseWebJson.page.layoutOption
  })
  for (let i = 1; i < allWebJson.length; i++) {
    //数据解密并合并
    const tempUrl = allWebJson[i].config.url
    const tempPageId = tempUrl.slice(tempUrl.indexOf("webjson") + "webjson/".length, tempUrl.indexOf("content") - 1)

    let stageItem = JSON.parse(allWebJson[i].data.data)
    const tempWebJson = decrypt(JSON.stringify(stageItem), data_dictionary_map)

    Object.assign(allEvent, event.createPageId(tempWebJson.event, tempPageId))
    // tempWebJson.event = event.createPageId(tempWebJson.event, tempPageId)
    if (tempWebJson.page.children.some(stage => typeof stage !== "object")) {
      continue
    }
    tempWebJson.page.children.forEach(stage => {
      stage.pageId = tempPageId
      stage.stageType = tempWebJson.page.stageType
      stage.layoutOption = tempWebJson.page.layoutOption
      stage.width = tempWebJson.page.pageWidth
      stage.height = tempWebJson.page.height
    })
    baseWebJson.page.children.push(...tempWebJson.page.children)
    console.log(baseWebJson.page.children)
  }
  event.init(allEvent, "stage")
  //把rem转回px
  reverseBuildModelForBigScreen(baseWebJson)
  //清除组件的active
  clearActive(baseWebJson)
  return baseWebJson
}
function clearActive(resultData) {
  resultData.page.children.forEach(containerItem => {
    containerItem.active == true ? (containerItem.active = false) : ""
    containerItem.children.forEach(rectsItem => {
      rectsItem.active == true ? (rectsItem.active = false) : ""
    })
  })
}
